import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow.svg';

export default function SelectAbsenceBox(props) {
  const {
    absenceStart,
    absenceEnd,
    setAbsenceStart,
    setAbsenceEnd
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target 
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target 
      && !ButtonRef.current.contains(e.target)) {
        setIsClicked(false);
    }
  }

  // 시작일 변경시 //
  function onChangeAbsenceStart(e) {
    let regex = /[^0-9]/g;				                  // 숫자가 아닌 문자열을 매칭하는 정규식
    let result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
    
    if (result === "") setAbsenceStart(0);
		else setAbsenceStart(parseInt(result));
  }

  // 시작일 포커스 없어진 경우 //
  function onBlurAbsenceStart() {
    if (absenceStart !== '' && absenceEnd !== '') {
      if (absenceStart > absenceEnd) setAbsenceEnd(absenceStart);
    }
  }

  // 종료일 변경시 //
  function onChangeAbsenceEnd(e) {
    let regex = /[^0-9]/g;				                  // 숫자가 아닌 문자열을 매칭하는 정규식
    let result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
    
    if (result === "") setAbsenceEnd(0);
		else setAbsenceEnd(parseInt(result));
  }

  // 종료일 포커스 없어진 경우 //
  function onBlurAbsenceEnd() {
    if (absenceStart !== '' && absenceEnd !== '') {
      if (absenceStart > absenceEnd) setAbsenceEnd(absenceStart);
    }
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} onClick={() => setIsClicked(!isClicked)}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.absencePeriod')}</Text>
        {
          (absenceStart === 0 && absenceEnd === 0) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledDownArrow width={10} height={6} color={theme.text} />
          </ArrowWrapper>
        }
        {
          (absenceStart !== 0 || absenceEnd !== 0) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>:</Text>
        }
        {
          (absenceStart !== 0 && absenceStart < absenceEnd) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{absenceStart + ' ' + t('messageSend.memberSelect.filter.dayUnit')}</Text>
        }
        {
          ((absenceStart !== 0 || absenceEnd !== 0) && absenceStart >= absenceEnd) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{absenceStart + ' ' + t('messageSend.memberSelect.filter.dayUnit')}</Text>
        }
        {
          ((absenceStart !== 0 || absenceEnd !== 0) && absenceStart < absenceEnd) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{absenceStart !== 0 ? ('~ ' + absenceEnd + ' ' + t('messageSend.memberSelect.filter.dayUnit')) : (absenceEnd + ' ' + t('messageSend.memberSelect.filter.dayUnit'))}</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} isDark={isDark}>
        <InputTotalWrapper>
          <InputWrapper>
            <Input
		          value={absenceStart}
		          onChange={onChangeAbsenceStart}
              onBlur={onBlurAbsenceStart}
              placeholder='0'/>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('messageSend.memberSelect.filter.dayUnit')}</Text>
          </InputWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>~</Text>
          <InputWrapper>
            <Input
		          value={absenceEnd}
		          onChange={onChangeAbsenceEnd}
              onBlur={onBlurAbsenceEnd}
              placeholder='0'/>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('messageSend.memberSelect.filter.dayUnit')}</Text>
          </InputWrapper>
        </InputTotalWrapper>
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 4px;

  height: 20px;

  gap: 4px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 10px;
  height: 6px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(-180deg)` : `rotateZ(0deg)`};
`;

const StyledDownArrow = styled(DownArrowSvg)`
  & path {
    stroke: ${props => props.color};
  }

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 26px;

  width: 135px;
  height: ${props => props.isClicked ? `52px` : `0px`};

  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const InputTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 115px;  
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px; 
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;
	line-height: 20px;

  padding: 0px 6px;

  width: 19px;
  height: 30px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	::placeholder {
    color: ${props => props.theme.line};
	}
	
  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;